import { useState } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleDown } from '@fortawesome/free-solid-svg-icons'

function SidebarItem({ icon, label, isActive = false, link, onClick, hasDropdown = false, dropdownItems = [] }) {
  const [isOpen, setIsOpen] = useState(false)
  const toggleDropdown = (e) => {
    if (hasDropdown) {
      e.preventDefault()
      setIsOpen(!isOpen)
    }
  }

  if (hasDropdown) {
    return (
      <div className="sidebar-item-wrapper">
        <div 
          className={`sidebar-item ${isActive ? 'active' : ''}`} 
          onClick={toggleDropdown}
          style={{ cursor: 'pointer' }}
        >
          <span className="me-2">{icon}</span>
          <span>{label}</span>
          <span className="ms-auto">
             <FontAwesomeIcon icon={isOpen ? faAngleDown:faAngleRight} style={{fontSize: '14px'}}/>
          </span>
        </div>
        {isOpen && (
          <div className="d-flex flex-column my-1">
            {dropdownItems.map((item, index) => (
              <Link 
              key={index}
              to={item.link}
              className={`sidebar-item-dropdown ${item.isActive ? 'active' : ''}`}
              onClick={item.onClick}
              >
                <span className="me-1">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    )
  }

  return (
    <Link to={link} className={`sidebar-item ${isActive ? 'active' : ''}`} onClick={onClick}>
      <span className="me-2">{icon}</span>
      <span>{label}</span>
    </Link>
  )
}

export default SidebarItem